import { useContext as g, useState as a } from "react";
import $ from "../../../hooks/useDebounce.js";
import "../../../components/Breadcrumbs/index.js";
import "../../../components/Button/index.js";
import "react/jsx-runtime";
import "classnames";
import "reactjs-popup";
import { ThemeContext as b } from "../../../components/ThemeContext/index.js";
import "../../../modal-l0sNRNKZ.js";
import "react-i18next";
import "../../Input/index.js";
import "../../../components/Tooltip/index.js";
const J = ({
  loadingUrl: s,
  loadingMethod: o = "post",
  loadingParam: r = "query",
  loadingMapper: n
}) => {
  const { token: c, lang: f, apiUrl: u } = g(b), [h, l] = a(), [d, e] = a(!1), y = $((t) => {
    if (!s || t.trim().length <= 1)
      return;
    e(!0);
    const L = u + s + (o === "get" ? `?${r}=${t.trim()}` : "");
    fetch(L, {
      method: o,
      body: o === "post" ? JSON.stringify({ [r]: t.trim() }) : null,
      headers: { Authorization: `Bearer ${c}`, "X-Language": `${f}`, "Content-Type": "application/json" }
    }).then(async (i) => {
      const m = await i.json(), O = n ? n(m, t) : m.map((p) => ({ label: p, value: p }));
      l(O), setTimeout(() => e(!1));
    }).catch((i) => e(!1));
  }, 200);
  return { loadedOptions: h, isLoading: d, loadOptions: y };
};
export {
  J as default
};
